import { render, staticRenderFns } from "./addDiscounts.vue?vue&type=template&id=a26ab450"
import script from "./addDiscounts.vue?vue&type=script&lang=js"
export * from "./addDiscounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports